<template>
  <el-dialog v-model="dialogVisible" width="90%" center @closed="handleClose">
    {{ $t(errorMessage) }}
    <template #footer>
      <div class="text-center">
        <el-button class="full-w-button el-button--primary is-small" type="primary" @click="handleClose">
          {{ $t('OK') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'WorkCenterErrorDialog',
})
export default class WorkCenterErrorDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean
  @Prop({ type: String, default: '' }) errorMessage!: string

  get dialogVisible() {
    return this.modelValue
  }

  set dialogVisible(value: boolean) {
    this.$emit('update:modelValue', value)
  }

  handleClose() {
    this.dialogVisible = false
  }
}
</script>
